import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Col, Row } from "reactstrap";
import SeriesAccessorySearch from "./SeriesAccessorySearch";
import { useAccessory } from "../../context/AccessoryContext";
import AccessoryProgress from "./AccessoryProgress";

function SelectAccessorySeries({ onNext, progressItems }) {
  const { newAccessory, cloneAccessory, accessory } = useAccessory();
  const intl = useIntl();

  function onSeriesSelect(value) {
    newAccessory({ id: value.seriesId, name: value.series });
    onNext();
  }

  async function onAccessorySelect(value) {
    await cloneAccessory(value.id, value.seriesId, value.version);
    onNext();
  }

  return (
    <Row>
      <Col xl={3} className="d-sm-none d-xl-block">
        <AccessoryProgress onNext={accessory?.series ? onNext : null} items={progressItems}></AccessoryProgress>
      </Col>
      <Col xl={9}>
        <SeriesAccessorySearch
          hideEmpties={false}
          onSeriesSelect={onSeriesSelect}
          onAccessorySelect={onAccessorySelect}
          accessorySelectText={intl.formatMessage({
            id: "accessory_information.clone_accessory",
            defaultMessage: "Clone accessory",
          })}
          seriesSelectText={intl.formatMessage({
            id: "app.select-series",
            defaultMessage: "Select series",
          })}
        ></SeriesAccessorySearch>
      </Col>
    </Row>
  );
}

export default SelectAccessorySeries;
